import { render, staticRenderFns } from "./TemplatePerformanceDialog.vue?vue&type=template&id=47ab0c7d&scoped=true"
import script from "./TemplatePerformanceDialog.vue?vue&type=script&lang=js"
export * from "./TemplatePerformanceDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplatePerformanceDialog.vue?vue&type=style&index=0&id=47ab0c7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ab0c7d",
  null
  
)

export default component.exports